// Breakpoint sizes from Tailwind CSS
// https://tailwindcss.com/docs/screens
export const breakpoint = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};
